// delay between two refresh of catalog in milliseconds
export const REFRESH_CATALOG_DELAY = 60 * 3 * 1000
